import { ResultStatusEnum } from '@ztechapps/quickscore.contract/mobile'

/**
 * Display label per status — PendingReview reads as "Needs Review" everywhere it surfaces
 * (the results export email, the mobile results list). Shared with the mobile app through
 * the `quickscore.common/mobile` entry point so the two can never drift apart.
 */
export const RESULT_STATUS_LABEL: Record<ResultStatusEnum, string> = {
  [ResultStatusEnum.PendingReview]: 'Needs Review',
  [ResultStatusEnum.Completed]: 'Completed',
}
